import { _continue as _continue$1, continueWith as continueWith$1, done as done$1, isContinue as isContinue$1, isDone as isDone$1 } from '../../internal/schedule/decision.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

const _continue = _continue$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const continueWith = continueWith$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const done = done$1;

/**
 * @since 2.0.0
 * @category refinements
 */
const isContinue = isContinue$1;

/**
 * @since 2.0.0
 * @category refinements
 */
const isDone = isDone$1;

export { _continue as continue, continueWith, done, isContinue, isDone };
